import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CountResponse, DataOBJ, DataObjService, RestService} from './rest-service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CostCenterService implements DataObjService<CostCenter> {

  restHelper: RestService<CostCenter>;

  readonly apiPath = '/api/call_event/v1/cost_center';

  constructor(private httpClient: HttpClient) {
    this.restHelper = new RestService<CostCenter>(this.apiPath, httpClient, CostCenter.fromJSON)
  }

  countByNumberAndCustomerId(number: number, customerId: string): Observable<number> {
    return this.httpClient.get<CountResponse>(this.apiPath + `/count/customer/${customerId}/number/${number}`)
      .map((res: CountResponse) => res.count);
  }

  getAll(): Observable<CostCenter[]> {
    return this.restHelper.getAll();
  }

  getAllByCustomerId(customerId: string): Observable<CostCenter[]> {
    return this.restHelper.getAllByCustomerId(customerId);
  }

  getById(id: string): Observable<CostCenter> {
    return this.restHelper.getById(id);
  }

  save(obj: CostCenter): Observable<CostCenter> {
    return this.restHelper.save(obj);
  }

  update(obj: CostCenter): Observable<CostCenter> {
    return this.restHelper.update(obj);
  }

  delete(obj: CostCenter): Observable<string> {
    return this.restHelper.delete(obj);
  }
}

export class CostCenter implements DataOBJ {

  static fromJSON(json: any): CostCenter {
    const object: CostCenter = Object.create(CostCenter.prototype);
    Object.assign(object, json);
    return object;
  }

  constructor(public id: string, public description: string, public number: number, public customerId: string,
              public deleted: boolean) {
  }

  getHumanIdentifier() {
    return this.description + ' - ' + this.number;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/cost-center.service.ts